export default "__VITE_ASSET__D3MrF8Tn__"